import { ExternalConnectionsProviders } from '@griply/types';
import { DefaultError, useMutation } from '@tanstack/react-query';
import { getExternalAuthRedirected } from 'shared/services/backend-api';

export const useRedirectToExternalAuthMutation = () =>
  useMutation<void, DefaultError, ExternalConnectionsProviders>({
    mutationFn: async (provider) => await getExternalAuthRedirected(provider),
  });
